import { render, staticRenderFns } from "./about.vue?vue&type=template&id=ae091db4&scoped=true"
import script from "./about.vue?vue&type=script&setup=true&lang=js"
export * from "./about.vue?vue&type=script&setup=true&lang=js"
import style0 from "./about.vue?vue&type=style&index=0&id=ae091db4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae091db4",
  null
  
)

export default component.exports